export const backgrounds = {
  // Solid colors
  white: '#FFFFFF',
  ashy: '#0A0A0B',
  lightBlue: '#F8FEFF',
  purple: '#352A61',
  icoBlueLt: '#D5E6F6',
  icoBlue: '#2D80D2',
  icoBrownLt: '#F0E4DB',
  icoBrown: '#B2774D',
  icoRedLt: '#F6D5D5',
  icoRed: '#D22D2D',
  tomato: '#ff6347',
  navy: '#091A3B',

  // Blue gradient layers
  blueGradientDiagonal1: `linear-gradient(154.97deg, #9CCFD8 0%, rgba(255, 255, 255, 0) 75.69%)`,
  blueGradientDiagonal2: `linear-gradient(215.37deg, #7F7FD5 -3.52%, rgba(255, 255, 255, 0) 62%)`,
  blueGradientReverseDiagonal1: `linear-gradient(134.52deg, rgba(255, 255, 255, 0) 50.42%, rgba(127, 127, 213, 0.960784) 100%)`,
  blueGradientReverseDiagonal2: `linear-gradient(225.48deg, rgba(255, 255, 255, 0) 50.42%, #9CCFD8 100%)`,

  // Purple gradient layers
  purpleGradientDiagonal1: `linear-gradient(154.97deg, #352A61 0%, rgba(255, 255, 255, 0) 75.69%)`,
  purpleGradientDiagonal2: `linear-gradient(215.37deg, #9979B9 -3.52%, rgba(255, 255, 255, 0) 62%)`,
  purpleGradientReverseDiagonal1: `linear-gradient(134.52deg, rgba(255, 255, 255, 0) 50.42%, rgba(153, 121, 185, 0.960784) 100%)`,
  purpleGradientReverseDiagonal2: `linear-gradient(225.48deg, rgba(255, 255, 255, 0) 50.42%, #E0D7EA 100%)`,

  // Orange gradient layers
  orangeGradientDiagonal1: `linear-gradient(154.97deg, #FFF9EA 0%, rgba(255, 255, 255, 0) 75.69%)`,
  orangeGradientDiagonal2: `linear-gradient(215.37deg, #FBB954 -3.52%, rgba(255, 255, 255, 0) 62%)`,
  orangeGradientReverseDiagonal1: `linear-gradient(134.52deg, rgba(255, 255, 255, 0) 50.42%, rgba(251, 185, 84, 0.960784) 100%)`,
  orangeGradientReverseDiagonal2: `linear-gradient(225.48deg, rgba(255, 255, 255, 0) 50.42%, #FE6F01 100%)`,

  // Combined gradients
  blueGradientCombined: `linear-gradient(154.97deg, #9CCFD8 0%, rgba(255, 255, 255, 0) 75.69%), linear-gradient(215.37deg, #7F7FD5 -3.52%, rgba(255, 255, 255, 0) 62%)`,
  blueGradientReverseCombined: `linear-gradient(134.52deg, rgba(255, 255, 255, 0) 50.42%, rgba(127, 127, 213, 0.960784) 100%), linear-gradient(225.48deg, rgba(255, 255, 255, 0) 50.42%, #9CCFD8 100%)`,
  purpleGradientCombined: `linear-gradient(154.97deg, #352A61 0%, rgba(255, 255, 255, 0) 75.69%), linear-gradient(215.37deg, #9979B9 -3.52%, rgba(255, 255, 255, 0) 62%)`,
  purpleGradientTopBottom: `linear-gradient(180deg, rgba(53,42,97,1) 0%, rgba(53,42,97,1) 35%, rgba(255,255,255,1) 100%)`,
  purpleGradientTopBottom2: `linear-gradient(180deg, #352A61 10%, #9979B9 60%, #E0D7EA 80%, #FFFFFF 100%)`,
  purpleGradientReverseCombined: `linear-gradient(134.52deg, rgba(255, 255, 255, 0) 50.42%, rgba(153, 121, 185, 0.960784) 100%), linear-gradient(225.48deg, rgba(255, 255, 255, 0) 50.42%, #E0D7EA 100%)`,
  darkPurpleGradient: `linear-gradient(180deg, #352A61 50%, #9979B9 100%)`,
  orangeGradientCombined: `linear-gradient(154.97deg, #FFF9EA 0%, rgba(255, 255, 255, 0) 75.69%), linear-gradient(215.37deg, #FBB954 -3.52%, rgba(255, 255, 255, 0) 62%)`,
  orangeGradientReverseCombined: `linear-gradient(134.52deg, rgba(255, 255, 255, 0) 50.42%, rgba(251, 185, 84, 0.960784) 100%), linear-gradient(225.48deg, rgba(255, 255, 255, 0) 50.42%, #FE6F01 100%)`,

  // Mesh
  purpleBluePinkMesh: 'your_css_selector_here',
  purpleBluePinkMesh2: 'your_css_selector_here2',

  transparentPurpleGradientToBottom: `linear-gradient(to bottom, rgba(36, 37, 38, 0) 23.07%, rgba(153, 121, 185, 0.2) 61.53%, #9979B9 100%)`,
  charcoalBlackGradientToBottom:
    'linear-gradient(to bottom, #28292A 20.33%, #0A0A0B 60.38%)',
  charcoalBlackGradientToTop:
    'linear-gradient(to top, #28292A 20.33%, #0A0A0B 60.38%)',
  slateBlackGradientToBottom:
    'linear-gradient(to bottom, rgb(0, 0, 0), rgb(17, 24, 39), rgb(55, 65, 81))',
  slateBlackGradientToTtop:
    'linear-gradient(to top, rgb(0, 0, 0), rgb(17, 24, 39), rgb(55, 65, 81))',
  lightBlueGradientToBottom:
    'linear-gradient(to bottom, #0066A2 20.33%, #9BC6D9 60.38%)',
  lightBlueGradientToTop:
    'linear-gradient(to top, #0066A2 0%, #9BC6D9 40%, #9BC6D9 100%)',
  lightBlueGradientToBottom2:
    'linear-gradient(to bottom, #F8FEFF 0%, #9BC6D9 40%, #0066A2 100%)',
  lightBlueGradientToTop2:
    'linear-gradient(to top, #F8FEFF 0%, #9BC6D9 40%, #0066A2 100%)',
} as const;

export type BackgroundValue = keyof typeof backgrounds;

export const getBackground = (value: BackgroundValue): string => {
  return backgrounds[value];
};
